import React, { useEffect } from "react";
import { Mobile, Tablet, Desktop } from "../../../utils/deviceHelpers";
import Container from "@mui/material/Container";

export default function AuctionsPage(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="xl">
      <Mobile>
        <iframe
          src="https://auction.hooverandstrong.com/buy/customer/auction/auction-buyer.php"
          width="350px"
          height="900px"
          title="mobile"
        />
      </Mobile>
      <Tablet>
        <iframe
          src="https://auction.hooverandstrong.com/buy/customer/auction/auction-buyer.php"
          width="750px"
          height="900px"
          title="tablet"
        />
      </Tablet>
      <Desktop>
        <iframe
          src="https://auction.hooverandstrong.com/buy/customer/auction/auction-buyer.php"
          width="1500px"
          height="900px"
          title="default"
        />
      </Desktop>
    </Container>
  );
}
